import { Package, Clock, CheckCircle, DollarSign } from "lucide-react";

export const AdminStats = ({ stats }) => {
  if (!stats) return null;

  const cards = [
    { icon: Package, label: "Total Orders", value: stats.total_orders, color: "blue", testId: "stat-total" },
    { icon: Clock, label: "Pending", value: stats.pending_orders, color: "yellow", testId: "stat-pending" },
    { icon: CheckCircle, label: "Completed", value: stats.completed_orders, color: "green", testId: "stat-completed" },
    { icon: DollarSign, label: "Revenue", value: `$${stats.total_revenue.toLocaleString()}`, color: "red", testId: "stat-revenue" },
  ];

  const colorMap = {
    blue: { bg: "bg-blue-50", text: "text-blue-600" },
    yellow: { bg: "bg-yellow-50", text: "text-yellow-600" },
    green: { bg: "bg-green-50", text: "text-green-600" },
    red: { bg: "bg-red-50", text: "text-celebration-red" },
  };

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-testid="admin-stats">
      {cards.map(({ icon: Icon, label, value, color, testId }) => (
        <div key={label} className="bg-white rounded-xl p-5 border border-gray-100 shadow-sm">
          <div className="flex items-center gap-3 mb-2">
            <div className={`w-10 h-10 ${colorMap[color].bg} rounded-lg flex items-center justify-center`}>
              <Icon className={`w-5 h-5 ${colorMap[color].text}`} />
            </div>
            <span className="text-sm text-gray-500">{label}</span>
          </div>
          <p className={`text-3xl font-bold ${colorMap[color].text}`} data-testid={testId}>{value}</p>
        </div>
      ))}
    </div>
  );
};
